import { css, createGlobalStyle } from 'styled-components';
import React from 'react';
import theme from 'lib/theme';
import color from 'color';

const getText = (selector: string, $color: string) => {
  return css`
    .${selector} {
      color: ${$color}!important;
      a& {
        color: ${$color}!important;
        &:hover,
        &:focus {
          opacity: 0.9;
          outline: none;
        }
      }
    }
  `;
};

const Text = createGlobalStyle`
  ${getText('text-primary', 'var(--color-primary)')};
  ${getText('text-info', theme.color.info)};
  ${getText('text-warn', theme.color.warn)};
  ${getText('text-danger', theme.color.warn)};
  ${getText('text-success', theme.color.success)};
  ${getText('text-second', theme.color.second)};

  .text-hidden {
    overflow: hidden;
    text-indent: 100%;
    white-space: nowrap;
  }

  .text-overflow {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    vertical-align: middle;
    display: inline-block;
  }

  .text-break {
    word-wrap: break-word;
    word-break: break-all;
    vertical-align: middle;
  }

  .text-left {
    text-align: left;
  }

  .text-center {
    text-align: center;
  }

  .text-right {
    text-align: right;
  }
 `;

export default Text;
